import { Flex, Pagination as AntPagination, TablePaginationConfig } from "antd";
import { isEmpty } from "@/lib/utils";
export const Pagination = ({
  ...rest
}: TablePaginationConfig) => {
  return <>
            <AntPagination showQuickJumper locale={{
      page: ''
    }} showSizeChanger={false} {...rest} data-sentry-element="AntPagination" data-sentry-source-file="index.tsx" />
        </>;
};
export const PaginationWrapped = ({
  ...rest
}: TablePaginationConfig) => {
  return <>
            {!isEmpty(rest) ? <>
                        <Flex justify={'flex-end'} style={{
        marginTop: '16px',
        marginRight: '-8px'
      }}>
                            <Pagination showQuickJumper locale={{
          page: ''
        }} showSizeChanger={false} {...rest} />
                        </Flex>
                    </> : null}

        </>;
};